import { Controller } from '@hotwired/stimulus'

// the goal of this controller was to prevent opening modal on new tabs - which was not working
export default class extends Controller {
  static targets = ['modalFrameTag']

  openModal(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.path || event.currentTarget.href
    const frame = event.currentTarget.dataset.turboFrame
      ? document.querySelector(`turbo-frame#${event.currentTarget.dataset.turboFrame}`)
      : this.modalFrameTagTarget

    frame.src = url
    frame.reload()
  }
}
